module.exports = "/images/welcome-bg.svg?1c68bf3a86cf6529427832f595c26341";